import React from 'react';

import { Product } from 'types/state';
import { useIntlDictionary } from 'hooks/useIntlDictionary';
import {
  TableTr,
  TableWrapper,
  TableHead,
  TableTh,
  TableBody,
} from 'design/table';
import { ProductsTableRow } from 'containers/ProductsTable';

type Props = {
  items: Product[];
  activeItemId?: number;
  onItemClick(item: number): void;
};

export const ProductsTable = (props: Props) => {
  const { items, activeItemId, onItemClick } = props;

  const { productsTableColumns: intl } = useIntlDictionary();

  const tableRowsNode = React.useMemo(() => {
    return items.map((item) => (
      <ProductsTableRow
        key={item.id}
        active={activeItemId === item.id}
        item={item}
        onClick={onItemClick}
      />
    ));
  }, [items, activeItemId, onItemClick]);

  return (
    <TableWrapper>
      <TableHead>
        <TableTr>
          <TableTh size="xs" text={intl.id} />
          <TableTh size="auto" text={intl.name} />
          <TableTh size="m" text={intl.actualCost} />
        </TableTr>
      </TableHead>
      <TableBody>{tableRowsNode}</TableBody>
    </TableWrapper>
  );
};
